(function () {
    'use strict';

    angular.module("imApp").factory("interBranchMultiGetService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 790,
                    parameters: parms || {}
                });
            },
            listLevels: function (parms) {
                return $ihttp.post({
                    method: 791,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
